const VISIBLE_DIGITS_COUNT = 2;
const MASKED_GROUP = "••";
const MASKED_GROUPS_COUNT = 3;

// "0612345642" → "06 •• •• •• 42": enough to recognise the number without
// displaying it in full.
export const maskCellPhone = (cellPhone: string | null | undefined): string | null => {
  const digits = (cellPhone ?? "").replace(/\D/g, "");
  if (digits.length < VISIBLE_DIGITS_COUNT * 2) return null;

  const maskedGroups = Array.from({ length: MASKED_GROUPS_COUNT }, () => MASKED_GROUP).join(" ");
  return `${digits.slice(0, VISIBLE_DIGITS_COUNT)} ${maskedGroups} ${digits.slice(-VISIBLE_DIGITS_COUNT)}`;
};
